import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})
export class FaqComponent implements OnInit {

  faqId: number = 1;
  faqList: any = [
    {
      id: 1,
      question: 'What products does Golden Drop Oils offer?',
      answer: 'GOLDOL delivers premium lubricant products that contain synthetic semisynthetic mineral oil solutions which work well for gasoline and diesel fuel systems. GOLDOL supplies the market using its products that support vehicles from all vehicle sizes including heavy-duty trucks and industrial machinery.'
    },
    {
      id: 2,
      question: "Are your engine oils suitable for the UAE climate?",
      answer: "Every GOLDOL engine oil from our company comes with special formulations designed specifically for high-temperature UAE environments. The oils demonstrate great resistance to high temperatures along with excellent protection against wear damage and maintain engine cleanliness."
    },
    {
      id: 3,
      question: "Do you supply bulk engine oils for workshops and fleets?",
      answer: "Absolutely. Our company extends wholesale engine oil supply for immediate delivery to service centers and commercial fleets operating throughout the UAE territory."
    },
    {
      id: 4,
      question: "What makes GOLDOL oils stand out from other brands?",
      answer: "The production process of GOLDOL oils involves base oils of superior quality combined with state-of-the-art additive technology. Our products achieve API SN/SL/CF international standards for delivering longer oil lifespan along with lower emissions and enhanced engine protection results."
    },
    {
      id: 5,
      question: "Where are your operations based?",
      answer: "Golden Drop operations based in Dubai and Sharjah provide customers throughout United Arab Emirates with efficient distribution together with supportive services."
    },
    {
      id: 6,
      question: "Can I buy GOLDOL oils for my personal vehicle?",
      answer: "The company welcomes personal customers among its client base. Our product range includes motor oils for every engine type that meet the requirements of all driving needs whether you use an SUV or a compact car."
    },
    {
      id: 7,
      question: "How can I place an order?",
      answer: "Our website shows our product list while you can contact us through the contact form along with phone and email options. Our team helps you select the appropriate product together with delivery organization."
    },
    {
      id: 8,
      question: "Do your products meet OEM specifications?",
      answer: "Our GOLDOL oils exceed the standards of Original Equipment Manufacturer specifications to offer compatibility with Toyota and Nissan cars alongside Honda models."
    },
    {
      id: 9,
      question: "How often should I change my engine oil?",
      answer: "Our recommendation for engine oil changes in UAE driving conditions ranges from 5,000 to 10,000 kilometers based on specific driving behaviors and chosen oil types."
    },
    {
      id: 10,
      question: "Are your oils eco-friendly?",
      answer: "Our company dedicating itself to sustainable operations. Our products decrease emission production and boost engine fuel efficiency which leads to better engine cleanliness and environmental wellbeing."
    }
  ];

  constructor(private titleService: Title, private metaService: Meta) { }

  ngOnInit() {
    this.titleService.setTitle('Frequently Asked Questions - GOLDOL Lubricants');
    this.metaService.updateTag({ name: 'description', content: 'Get answers to your questions about GOLDOL Lubricants. Learn more about our products, services, and company policies in our FAQ section.' });
    this.metaService.updateTag({ name: 'keywords', content: 'lubricant oil suppliers dubai' });
  }

  activeFaq(id: number) {
    this.faqId = id;
  }

}
